export default "__VITE_ASSET__dOOhO6xj__"